import type * as React from "react";
import { forwardRef } from "react";
import { styled, View, type ViewProps } from "tamagui";

const SkeletonBase: React.FC<ViewProps> = forwardRef((props, _ref) => {
  return (
    <View
      backgroundColor={"$divider"}
      opacity={0.5}
      maxWidth={"100%"}
      {...props}
    />
  );
});

export const Skeleton = styled(SkeletonBase, {
  acceptsClassName: true,
});
